module.exports = "mutation createFieldOfLaw($fieldOfLaw:FieldOfLawInput!){createFieldOfLaw(fieldOfLaw:$fieldOfLaw){name id}}"